import { createStore } from 'vuex';
import { getStoreOptions } from './options';

export const store = createStore(getStoreOptions());
